// © 2025 PyLocus. All rights reserved. Unauthorized use prohibited.
/**
 * Global JavaScript for Complaint Vrbovec
 */

document.addEventListener('DOMContentLoaded', () => {
    // 1. Flash Messages Auto-hide
    const flashMessages = document.querySelectorAll('.flash-message');
    flashMessages.forEach(message => {
        const msg = message as HTMLElement;
        setTimeout(() => {
            msg.style.opacity = '0';
            msg.style.transform = 'translateY(-10px)';
            msg.style.transition = 'opacity 0.5s ease-out, transform 0.5s ease-out';
            setTimeout(() => {
                msg.style.display = 'none';
            }, 500);
        }, 4000);
    });

    // 2. Profile Dropdown Toggle
    const profileBtn = document.getElementById('profile-menu-btn');
    const dropdown = document.getElementById('profile-dropdown');

    if (profileBtn && dropdown) {
        profileBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            dropdown.classList.toggle('show');
        });

        window.addEventListener('click', (event) => {
            const target = event.target as HTMLElement;
            if (!target.closest('.user-profile-menu')) {
                dropdown.classList.remove('show');
            }
        });
    }
    
    // 3. Search Takeover Logic
    const searchRevealBtn = document.getElementById('search-reveal-btn');
    const searchCloseBtn = document.getElementById('search-close-btn');
    const searchTakeover = document.getElementById('header-search-takeover');
    const searchInput = document.getElementById('takeover-search-input') as HTMLInputElement;

    if (searchRevealBtn && searchTakeover && searchInput) {
        const showSearch = () => {
            searchTakeover.classList.add('active');
            document.body.style.overflow = 'hidden'; // Prevent scroll
            setTimeout(() => searchInput.focus(), 100);
        };

        const hideSearch = () => {
            searchTakeover.classList.remove('active');
            document.body.style.overflow = '';
            searchInput.value = ''; // Clear on close
        };

        searchRevealBtn.addEventListener('click', showSearch);

        if (searchCloseBtn) {
            searchCloseBtn.addEventListener('click', hideSearch);
        }

        // Close on ESC
        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && searchTakeover.classList.contains('active')) {
                hideSearch();
            }
        });

        // Close when clicking outside of the search bar content
        window.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            if (searchTakeover.classList.contains('active') && !target.closest('.search-takeover-form') && !target.closest('#search-reveal-btn')) {
                hideSearch();
            }
        });
    }

    // 6. Mobile Menu Toggle
    const mobileMenuBtn = document.getElementById('mobile-menu-btn');
    const mobileMenuClose = document.getElementById('mobile-menu-close');
    const mobileNav = document.getElementById('mobile-nav');

    if (mobileMenuBtn && mobileNav) {
        mobileMenuBtn.addEventListener('click', () => {
            mobileNav.classList.add('active');
            document.body.style.overflow = 'hidden';
        });

        const closeMobileMenu = () => {
            mobileNav.classList.remove('active');
            document.body.style.overflow = '';
        };

        if (mobileMenuClose) {
            mobileMenuClose.addEventListener('click', closeMobileMenu);
        }

        // Close on escape
        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeMobileMenu();
        });

        // Close when clicking outside (on the overlay)
        mobileNav.addEventListener('click', (e) => {
            if (e.target === mobileNav) closeMobileMenu();
        });
    }

    // 4. Back to Top Smooth Scroll
    const backToTopBtn = document.querySelector('.back-to-top-btn') as HTMLElement;
    if (backToTopBtn) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 300) {
                backToTopBtn.style.opacity = '1';
                backToTopBtn.style.pointerEvents = 'auto';
            } else {
                backToTopBtn.style.opacity = '0';
                backToTopBtn.style.pointerEvents = 'none';
            }
        });

        backToTopBtn.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }

    // 4. Lazy Loading Images
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target as HTMLImageElement;
                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                        img.classList.remove('lazy');
                        observer.unobserve(img);
                    }
                }
            });
        });

        const lazyImages = document.querySelectorAll('img.lazy');
        lazyImages.forEach(img => imageObserver.observe(img));
    }

});

// 5. Global Complaint Card Click Handler - Outside DOMContentLoaded for maximum reliability
document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    const card = target.closest('.complaint-card') as HTMLElement;

    if (card) {
        console.log('[Complaints] Card click target:', target);
        
        // If click is on a link or something that should stop propagation (like profile links or buttons)
        const stopProp = target.closest('.stop-prop');
        const link = target.closest('a');
        
        if (stopProp || link) {
            console.log('[Complaints] Click ignored: on link or stop-prop element');
            return;
        }

        const url = card.getAttribute('data-url');
        console.log('[Complaints] Redirecting to:', url);
        if (url) {
            window.location.href = url;
        } else {
            console.error('[Complaints] Card missing data-url attribute!');
        }
    }
});
